import React, {useState} from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {Menu as MenuIcon} from "@mui/icons-material";
import {List, ListItem, SwipeableDrawer} from "@mui/material";
import Button from "@mui/material/Button";
import {NavLink} from "react-router-dom";

const HeaderMobileMenuButton: React.FC = () : JSX.Element => {
    const [open, setOpen] = useState(false); // Состояние для контроля открытия и закрытия SwipeableDrawer

    // Открытие Drawer
    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        setOpen(open);
    };


    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
                <IconButton
                    size="large"
                    // edge="start"
                    edge="end"
                    color="inherit"
                    onClick={toggleDrawer(true)}
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
                    <MenuIcon />
                </IconButton>
            </Box>
            {/* SwipeableDrawer, который открывается справа */}
            <SwipeableDrawer
                anchor="right" // Открывается справа
                open={open} // Открытие/закрытие
                onClose={toggleDrawer(false)} // Закрытие при клике вне Drawer
                onOpen={() => {}} // Нет действий при открытии, но нужно передать функцию
                sx={{
                        '& .MuiDrawer-paper': {
                            backgroundColor: '#673AB7', // Устанавливаем цвет фона
                        },
                    }}
            >
                {/* Содержимое Drawer */}
                <List>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/"
                        >
                            Главная
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/rules"
                        >
                            ПРАВИЛА
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/product"
                        >
                            ПРОДУКТ
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/service"
                        >
                            УСЛУГА
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/timeline"
                        >
                            TIMELINE
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/prizes"
                        >
                            ПРИЗЫ
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/organizers"
                        >
                            ОРГАНИЗАТОР
                        </Button>
                    </ListItem>
                    <ListItem button onClick={toggleDrawer(false)}>
                        <Button
                            variant="text"
                            color="secondary"
                            component={NavLink}
                            to="/sponsors"
                        >
                            СПОНСОРЫ
                        </Button>
                    </ListItem>
                </List>
            </SwipeableDrawer>
        </>
    )
};

export default HeaderMobileMenuButton;